export const config = {
  tokenKEY: "token",
  phoneKEY: "phone",
  backendTokenKEY: "Authorization",
};

export const CUSTOM_API_ROOT_PROD = "https://exact-web-backend.bis-apps.com/";
// export const CUSTOM_API_ROOT_TEST =
//   "https://exact-web-test-backend.bis-apps.com/";
export const CUSTOM_API_ROOT_TEST = "https://exact-web-backend.bis-apps.com/";
